module.exports = "/_next/static/images/MobileFourthProcess-b7f5b56ec295090fe9fb6d6db69158bd.png";